import { render, staticRenderFns } from "./UmbracoImageExt.vue?vue&type=template&id=5f269fc5&"
import script from "./UmbracoImageExt.vue?vue&type=script&lang=js&"
export * from "./UmbracoImageExt.vue?vue&type=script&lang=js&"
import style0 from "./UmbracoImageExt.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports